import { render, staticRenderFns } from "./MapKab.vue?vue&type=template&id=32364c76&scoped=true"
import script from "./MapKab.vue?vue&type=script&lang=js"
export * from "./MapKab.vue?vue&type=script&lang=js"
import style0 from "./MapKab.vue?vue&type=style&index=0&id=32364c76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32364c76",
  null
  
)

export default component.exports